import * as React from 'react';
import PropTypes from 'prop-types';
import Slider, { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Heart from '../assets/heart.svg';
import GreyHeart from '../assets/greyHeart.svg';
import '../styles/sliderStyle.css';
import { useState } from 'react';
import { useEffect } from 'react';

const TipServiceSlider = styled(Slider)(({ theme }) => ({
    color: '#8E61E9',
    height: 0,
    '& .MuiSlider-thumb': {
        height: 0,
        width: 0,
    },
    '& .MuiSlider-rail': {
        color: '#d8d8d8',
        opacity: 1,
        height: 3,
    },
    '& .MuiSlider-track': {
        height: 3,
        border: 0
    },
}));

function AirbnbThumbComponent(props) {
    const { children, disabled, ...other } = props;
    return (
        <SliderThumb sx={{ PointerEvent: 'none !important' }} {...other}>
            {children}
            <img src={disabled ? GreyHeart : Heart} width={24} />
        </SliderThumb>
    );
}

AirbnbThumbComponent.propTypes = {
    children: PropTypes.node,
    value: PropTypes.number.isRequired,
    disabled: PropTypes.bool.isRequired
};

const formatPrice = (value) => {
    const floatValue = parseFloat(value);
    if ( floatValue >= 0 && floatValue.toString().split('.')[1]?.length === 1) {
      return floatValue.toFixed(2);
    }  else if (Number.isInteger(floatValue)) {
        return floatValue.toFixed(2);
      } else {
      return floatValue.toString();
    }
}

export default function SliderComponent({ setCreditApplied, setTotalAmount,setSliderValue,...props }) {


    const [tooltipOpen, setTooltipOpen] = useState(true);
    const [value, setValue] = useState(props?.sharedData?.donationAmount?.givesomeTipPercentage === 0 ? props?.sharedData?.donationAmount?.givesomeTipPercentage : 15);
    const [amount, setAmount] = useState();
    const [price, setPrice] = useState(0);
    const [thumbState, setThumbState] = useState();
    const [currencySymbol, setCurrencySymbol] = useState(props?.currencySymbol);
    const valueLabelStyles = value > 25 ? { right: '-20px' } : {};

    useEffect(() => {
        setThumbState(props.disabled);
        setAmount(prevState => props.amount);
        setCreditApplied(prevState => props?.sharedData?.donationAmount?.creditApplied ? props.sharedData.donationAmount?.creditApplied : props?.amount  ? (props?.amount * (value / 100) ) :0.00 );
        setPrice(prevState => props?.sharedData?.donationAmount?.creditApplied ? props.sharedData.donationAmount?.creditApplied : props?.amount  ? (props?.amount * (value / 100) ) :"");
        setTooltipOpen(true);
        handleChange(undefined, props.sliderValue);
        setCurrencySymbol(props?.currencySymbol);

    }, [props.disabled, props.amount,amount, props.currencySymbol]);

    const handleChange = (event, newValue) => {
        setValue(prevState =>  newValue);
        setPrice(prevState => (amount * ( newValue) / 100));
        setCreditApplied(preState => (amount * ( newValue) / 100));
        setTotalAmount(Number(props.amount) + Number((amount * ( newValue) / 100)));
        setSliderValue(prevState => newValue);
    };

    return (
        <Box sx={{ width: "100%", mt: '70px' }}>
            <Box sx={{ m: 3 }} />
            <TipServiceSlider
                id='slider'
                aria-label="Always visible"
                sx={{
                    '& .MuiSlider-valueLabel': {
                        ...valueLabelStyles,
                        '&.MuiSlider-valueLabelOpen': {
                            ...valueLabelStyles,
                        },
                    },
                }}
                valueLabelDisplay={props.disabled?"off":"on"}
                slots={{
                    thumb: (props) => <AirbnbThumbComponent {...props} disabled={thumbState} />,
                }}
                valueLabelFormat={(value) => <Tooltip className={value>25 ? 'tooltip-right':""}
                    // enterTouchDelay={0}> {<div className='sub-head-3'> <span className='sub-head-2'>{price === 0 ? "" :`${currencySymbol}` +`${formatPrice(price)}`}</span> {`(${value}%)`}</div>}</Tooltip>} 
                    enterTouchDelay={0}> {<div className='sub-head-3'>{`${value}%`}</div>}</Tooltip>} 
                onChange={handleChange}
                getAriaLabel={(index) =>
                    index === 0 ? 'Minimum price' : 'Maximum price'
                }
                defaultValue={props?.sharedData?.donationAmount?.givesomeTipPercentage ? props?.sharedData?.donationAmount?.givesomeTipPercentage : props?.sharedData?.donationAmount?.givesomeTipPercentage === 0 ? 0 : 15}
                step={5}
                max={30}
                disabled={props.disabled}
            />
        </Box>
    );
}